export const engagementAppGroupIdContentBlocksIdPreviewThumbnail =
  "/engagement/:app_group_id/content_blocks/:id/preview_thumbnail";
